import { AUTH_PASSWORD_SHOW } from 'portal/constants/Routes';
import { buttonStyles, loginButtonStyles } from 'auth/AuthStyles';
import { connect } from 'react-redux';
import { passwordChangeAction } from 'reg_redesign/actions';
import { passwordMapDispatchToProps } from 'reg_redesign/redux/connectFunctions';
import { putData } from 'helpers/RequestHelper';
import { useSearchParams } from 'react-router-dom';
import Button from '@opploans/button-component/Button';
import PasswordWithConfirmation from 'components/component_lib/PasswordWithConfirmation';
import React, { useEffect } from 'react';

const id = 'password';

const mapStateToProps = (state) => {
  return {
    value: state.password,
    additionalProp: state.additionalProps.password
  };
};

const additionalButtonStyles = {
  width: '100%'
};

const mapDispatchToProps = passwordMapDispatchToProps({
  props: {
    id,
    onMount: passwordChangeAction,
    onChange: passwordChangeAction
  }
});

function PasswordEditAndConfirm({
  additionalProp,
  onChange,
  onMount,
  value,
  navigate
}) {
  const [searchParams] = useSearchParams();
  const resetPasswordToken = searchParams.get('reset_password_token');

  const [disabled, setDisabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const failedValidation = additionalProp?.validationsDisplay?.find(
      (result) => result.status !== 'pass'
    );
    const pastValidation = additionalProp?.previousPassword === 'pass';
    setDisabled(!(!failedValidation && pastValidation));
  }, [additionalProp]);

  const executeResetPassword = async () => {
    const response = await putData({
      url: AUTH_PASSWORD_SHOW,
      body: {
        user: { password: value, reset_password_token: resetPasswordToken }
      }
    });
    if (response.data?.error) {
      setLoading(false);
      window.toastr.error(response.data?.error);
    } else {
      window.toastr.success(
        null,
        'Your password has been changed successfully.'
      );
    }
    if (response.data?.redirect) {
      navigate(response.data.redirect);
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    await executeResetPassword();
  };

  return (
    <>
      <PasswordWithConfirmation
        additionalProp={additionalProp}
        onChange={onChange}
        onMount={onMount}
        value={value}
        useConfirmation
        checkPreviousPasswords
      />
      <Button
        disabled={disabled}
        loading={loading}
        css={{
          ...buttonStyles,
          ...additionalButtonStyles,
          ...loginButtonStyles
        }}
        onClick={handleSubmit}
      >
        Confirm New Password
      </Button>
    </>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordEditAndConfirm);
